import type { AlertListProps } from '../../../types/alerts.d';

import React from 'react';
import { AlertList } from '/react4xp/parts/alertList/AlertList';


export default function (props: AlertListProps): React.JSX.Element {
	return <AlertList {...props} />;
}
